import { motion, useReducedMotion } from "framer-motion";

interface SectionHeadingProps {
  id: string;
  title: string;
  subtitle?: string;
  prefix?: "//" | ">";
}

export function SectionHeading({ id, title, subtitle, prefix = "//" }: SectionHeadingProps) {
  const reduce = useReducedMotion();

  return (
    <motion.header
      className="mb-10 max-w-2xl"
      initial={reduce ? false : { opacity: 0, y: 16 }}
      whileInView={reduce ? undefined : { opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.4 }}
      transition={{ duration: 0.45 }}
    >
      <p className="mb-2 font-heading text-sm font-medium text-accent-terminal" aria-hidden>
        {prefix} {title.toLowerCase()}
      </p>
      <h2 id={id} className="font-heading text-3xl font-bold tracking-tight text-primary md:text-4xl">
        {title}
      </h2>
      {subtitle && <p className="mt-3 text-lg text-muted">{subtitle}</p>}
    </motion.header>
  );
}
